<template>
  <div class="wrapperEditPatient w3-padding">
    <p>
      <select @change="flagUnsaved()" class="w3-select" v-model="prison_id" required>
        <option
          v-for="prison in this.$store.state.prisonList"
          v-bind:key="prison.prison_id"
          v-bind:value="prison.prison_id"
        >{{prison.name}}</option>
      </select>
      <label>დაწესებულება</label>
    </p>
    <p>
      <input
        @change="validateIdNumber()"
        type="text"
        class="w3-input"
        placeholder="00112233445"
        v-model="id_number"
      >
      <label>ID ნომერი</label>
      <span v-if="idIsDuplicate" class="w3-button w3-red">"მოცემული იდ ნომრით პაციენტი უკვე არსებობს"</span>
    </p>
    <p>
      <input
        @change="flagUnsaved()"
        type="text"
        class="w3-input"
        placeholder="სახელი"
        v-model="name"
        required
      >
      <label>სახელი</label>
    </p>
    <p>
      <input
        @change="flagUnsaved()"
        type="text"
        class="w3-input"
        placeholder="გვარი"
        v-model="surname"
        required
      >
      <label>surname</label>
    </p>
    <p>
      <select @change="flagUnsaved()" class="w3-select" placeholder="სქესი" v-model="sex">
        <option value="მამრობითი">♂ მამრობითი</option>
        <option value="მდედრობითი">♀ მდედრობითი</option>
      </select>
      <label>sex</label>
    </p>
    <p>
      <span class="w3-third">
        <input
          @change="flagUnsaved()"
          type="number"
          class="w3-input"
          min="1"
          max="31"
          placeholder="xx"
          v-model="date_day"
          v-bind:class="{'w3-red': invalid_input.date_day}"
        >
        <label class="w3-margin-left">day</label>
      </span>
      
      <span class="w3-third">
        <input
          @change="flagUnsaved()"
          type="number"
          class="w3-input"
          min="1"
          max="12"
          placeholder="xx"
          v-model="date_month"
          v-bind:class="{'w3-red': invalid_input.date_month}"
        >
        <label class="w3-margin-left">month</label>
      </span>
      
      <span class="w3-third w3-padding-right" >
        <input
          @change="flagUnsaved()"
          type="number"
          class="w3-input"
          min="1800"
          max="2050"
          placeholder="xxxx"
          v-model="date_year"
          v-bind:class="{'w3-red': invalid_input.date_year}"
        >
        <label class="w3-margin-left">year</label>
      </span>
      <label>date_of_birth</label>
    </p>
    <p>
      <input
        @change="flagUnsaved()"
        type="text"
        class="w3-input"
        placeholder="5xxxxxx"
        v-model="mobile_number"
      >
      <label>mobile_number</label>
    </p>
    <p>
      <input
        @change="flagUnsaved()"
        type="text"
        class="w3-input"
        placeholder="x@x.x"
        v-model="email"
      >
      <label>eMail</label>
    </p>
    <p>
      <button class="w3-button" @click="savePatientData()">Save</button>
      <span class="w3-button">{{dataSaveStatus}}</span>
      <button class="w3-button w3-hover-red" @click="resetInput()">Clear</button>
    </p>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from 'vuex';

var api_path = "/php_scripts/";
if (process.env.NODE_ENV === "development") {
  api_path = "http://localhost/php_scripts/";
}
export default {
  name: "EditPatient",
  // components: {"patient-card": PatientCard},
  props: ["patientData"],
  data: function() {
    var data = {};
    console.log(this.patientData);
    var baseData = {
      dataSaveStatus: "Not Updated",
      invalid_input: {date_year: false, date_month: false, date_day: false},
      idIsDuplicate: false
    };
    if (this.patientData) {
      console.log("patient data 1");
      var date_of_birth_tokens = ["", "", ""];
      if (
        this.patientData.date_of_birth &&
        this.patientData.date_of_birth != "" &&
        this.patientData.date_of_birth != "0000-00-00"
      )
        date_of_birth_tokens = this.patientData.date_of_birth.split("-");
      return {
        ...this.patientData,
        ...baseData,
        date_year: date_of_birth_tokens[0],
        date_month: date_of_birth_tokens[1],
        date_day: date_of_birth_tokens[2]
      };
    } else {
      return {
        ...baseData,
        patient_id: null,
        prison_id: "",
        id_number: "",
        name: "",
        surname: "",
        sex: "",
        date_year: "",
        date_month: "",
        date_day: "",
        mobile_number: "",
        email: ""
      };
    }
  },
  computed: {
    ...mapGetters({findPatientByIdNumber:'findPatientByIdNumber'})
  },
  methods: {
    flagUnsaved() {
      this.dataSaveStatus = "Not Saved";
    },
    flagSaved() {
      this.dataSaveStatus = "Saved OK!";
    },
    flagSaveFailed() {
      this.dataSaveStatus = "Save Failed";
    },
    flagSaveing() {
      this.dataSaveStatus = "Saving....";
    },
    flagValidationFailed(){
      this.dataSaveStatus = "Validation Failed";
    },
    resetInput() {
      // console.log(this);
      this.patient_id = null;
      this.dataSaveStatus = "Not Updated";
      this.prison_id = null;
      this.name = "";
      this.surname = "";
      this.email = "";
      this.date_year = "";
      this.date_month = "";
      this.date_day = "";
      this.sex = null;
      this.mobile_number = "";
      this.id_number = "";
    },
    validateData(){
      let formIsValid = true;
      if( this.date_year == '' && this.date_month == '' && this.date_day == '' ){
        return formIsValid
      }
      if( this.date_year < 1800 || this.date_year > 2100 ){
        this.invalid_input.date_year = true;
        formIsValid = false;
      } else {this.invalid_input.date_year = false}
      if( this.date_month < 1 || this.date_month > 12){
        this.invalid_input.date_month = true;
        formIsValid = false;
      } else {this.invalid_input.date_month = false}
      if( this.date_day < 1 || this.date_day > 31){
        this.invalid_input.date_day = true;
        formIsValid = false;
      } else {this.invalid_input.date_day = false}
      if(!formIsValid) {
        alert("form validation failed please inspect flagged fields");
      }
      return formIsValid;
    },
    validateIdNumber(){
      console.log("validating id number " + this.id_number)
      if(this.findPatientByIdNumber(this.id_number) != null){
        this.idIsDuplicate = true
        console.log("id Duplicate")
      } else {
        this.idIsDuplicate = false
        console.log("id Unique")
      }
    },
    savePatientData() {
      this.flagSaveing();
      if(this.validateData() == false) {
        this.flagValidationFailed();
        return;
      }
      var formData = new FormData();
      this.patientData
        ? formData.append("patient_id", this.patientData.patient_id)
        : 1;
      this.patient_id ? formData.append("patient_id", this.patient_id) : 1;

      formData.append("name", this.name);
      formData.append("surname", this.surname);
      formData.append("prison_id", this.prison_id);
      formData.append("father_name", "");
      formData.append("sex", this.sex);
      if(this.date_year!="" && this.date_year!=null){
        formData.append(
          "date_of_birth",
          this.date_year + "-" + this.date_month + "-" + this.date_day
        );
      } else {
        formData.append(
          "date_of_birth",
          ""
        );
      }
      formData.append("mobile_number", this.mobile_number);
      formData.append("email", this.email);
      formData.append("id_number", this.id_number);

      // console.log(data);

      var store = this.$store;
      axios({
        method: "POST",
        url: api_path + "insert_patient_by_id_json.php",
        data: formData
      })
        .then(response => {
          console.log("response OK");
          console.log(response);
          response.data.type == "insert"
            ? (this.patient_id = response.data.patient_id)
            : 1;
          this.$store.dispatch("FETCH_PATIENT_LIST");
          this.flagSaved();
        })
        .catch(function(error) {
          console.log(error);
          console.log(this);
          this.flagSaveFailed();
        });
    }
  }
};
</script>

<style scoped>
.wrapperEditPatient {
  margin-top: 0px;
}
</style>
